import { connect } from 'react-redux';

import { selectSelectedDurationFilter } from '../../Schedules.selectors';
import { setSchedulesBoardDurationsFilters } from '../../Schedules.reducers';
import ScheduleBoardDurationFilter from './ScheduleBoardDurationFilter';

const mapStateToProps = state => ({
  selectedDurations: selectSelectedDurationFilter(state),
});

const mapDispatchToProps = {
  updateSelection: durations => setSchedulesBoardDurationsFilters(durations),
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleBoardDurationFilter);
